import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatMenuModule } from '@angular/material/menu';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { TranslateDirective, TranslatePipe } from '@ngx-translate/core';
import { FormsModule } from '@angular/forms';
import { MultiSelectComponent } from './multi-select.component';

@NgModule({
    imports: [CommonModule, MatMenuModule, MatCheckboxModule, TranslatePipe, TranslateDirective, FormsModule],
    declarations: [MultiSelectComponent],
    exports: [MultiSelectComponent]
})
export class MultiSelectModule {}
